export default "__VITE_ASSET__MKoXCRYO__"